import React, { useEffect, useState } from "react";
import { Label, Input, Button } from "reactstrap";
import Select from "react-select";

const SearchBar = ({
    searchCategory,
    searchOptions,
    searchTerm,
    onSearchCategoryChange,
    onSearchExecute
}) => {
    const [localSearchTerm, setLocalSearchTerm] = useState("");

    useEffect(() => {
        setLocalSearchTerm(searchTerm || "");
    }, [searchTerm]);

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            onSearchExecute(localSearchTerm);
        }
    };

    const getPlaceholder = () => {
         if (searchCategory?.placHolder) {
            return searchCategory?.placHolder;
        }else{
            return "Search..."
        }; 
          
    };

    return (
        <div
            className="row mb-3 justify-content-end"
            style={{
                marginTop: "10px",
                marginLeft: "5px",
                alignItems: "flex-end",
            }}
        >
            <div className="col-md-2">
                <Label>Search By:</Label>
                <Select
                    value={searchCategory}
                    onChange={onSearchCategoryChange}
                    options={searchOptions}
                    placeholder="Select Field"
                    menuPortalTarget={
                        typeof document !== "undefined" ? document.body : null
                    }
                    styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                />
            </div>
            <div className="col-md-4">
                <Input
                    type="text"
                    placeholder={getPlaceholder()}
                    value={localSearchTerm}
                    onChange={(e) => setLocalSearchTerm(e.target.value)}
                    onKeyDown={handleKeyDown}
                />
            </div>
            <div className="" style={{ marginRight: "28px" }}>
                <Button color="primary" onClick={() => onSearchExecute(localSearchTerm)}>
                    <i className="fa fa-search"></i> Search
                </Button>
            </div>
        </div>
    );
};

export default SearchBar;